<!--Author: Michał Pawłowski-->
<template>
  <div style="padding: 0">
    <div class="row d-flex justify-content-center">
      <div class="col">
        <div class="search-filters">
          <div class="input-icons">
            <i class="fas fa-search icon" @click="runSearch">

            </i>
            <input
              v-on:keydown.enter="runSearch"
              id="search-text-input"
              ref="search-text-input"
              type="text"
              class="form-control"
              placeholder="Szukaj..."
              v-model="phraseToSearch"
            />

          </div>
          <div class="row" style="padding-left: 8px;">
            <div
              v-for="option in searchOptions"
              class="search-tool-bar"
              :key="option.ordinal"
            >
              <div class="search-tool-param">
                <label class="form-checkbox">
                  <input
                    type="radio"
                    v-model="searchByOption"
                    :value="option.ordinal"
                    name="search-option-radio"
                  />
                  <i class="form-icon"></i>
                  {{ option.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SearchBarComponent",
  components: { },
  props: {
    searchOptions: Array,
  },
  emits: ["searchAndFilterRequest"],
  data() {
    return {
      searchByOption: 0,
      phraseToSearch: "",
    };
  },
  computed: {},
  methods: {
    runSearch() {
      var searchAndFilterRequestPayload = {
        searchPhrase: this.phraseToSearch,
        type: this.searchByOption,
      };
      this.$emit("searchAndFilterRequest", searchAndFilterRequestPayload);
    },
  },
  watch: {},
};
</script>
<style scoped>
.search-tool-bar {
  float: left;
  clear: both;
  width: 30%;
  margin-top: 5px;
  margin-bottom: 5px;
}

.search-tool-param {
  float: left;
  width: 100%;
}

.search-tool-advanced {
  text-align: right;
  float: right;
  width: 30%;
}

.form-control {
  height: 50px;
  margin-bottom: 2px;
  width: 100%;
  padding: 10px;
;
}

.form-control:focus {
  /*background-color: aliceblue;*/
  box-shadow: none;
  border-color: #eee;
}

.input-box i {
  position: absolute;
  right: 13px;
  top: 15px;
  color: #ced4da;
}

.search-filters{
  background: #f8f8fb;
margin-left:16px;
  margin-right: 16px;
  padding:24px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.input-icons i {
  position: absolute;
  right: 1%;
  top: 10px;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  text-align: right;
}

.icon {
  padding: 10px;
  min-width: 40px;
}
</style>
